import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MemberInsurerServiceService } from '@app/modules/lps-member-login/services/member-insurer-service.service';
import { CountUpPipe } from '../../shared/pipes/count-up.pipe';
import { BehaviorSubject, Subject } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddApplicantComponent } from '../add-applicant/add-applicant.component';
import { ChartConfiguration, ChartType, ChartData, ChartOptions } from 'chart.js';
import { BaseChartDirective, NgChartsModule } from 'ng2-charts';
import { NoDataFoundComponent } from "../../shared/no-data-found/no-data-found.component";
import { StatusLablesComponent } from "../../shared/components/status-lables/status-lables.component";
import { EntityType } from '../../shared/share';
import { InitialsPipe } from "../../shared/pipes/intials.pipe";
import { Router } from '@angular/router';
import { MemberInsurerRestService } from '@app/modules/lps-member-login/services/member-insurer-rest.service';
import { insurerStatusCount } from '@app/modules/lps-member-login/models/phase1models';

@Component({
  selector: 'app-dashboard-distri',
  standalone: true,
  imports: [CommonModule, CountUpPipe, NgChartsModule, NoDataFoundComponent, StatusLablesComponent, InitialsPipe],
  templateUrl: './dashboard-distri.component.html',
  styleUrl: './dashboard-distri.component.scss'
})
export class DashboardDistriComponent {

  isSidebarExpanded: boolean = false;
  draftHoverTrigger$: Subject<void> = new Subject<void>();
  submittedAwaitingInsurerHoverTrigger$: Subject<void> = new Subject<void>();
  submittedAwaitingAcceptanceHoverTrigger$: Subject<void> = new Subject<void>();
  declinedByInsurerHoverTrigger$: Subject<void> = new Subject<void>();
  notTakenUpHoverTrigger$: Subject<void> = new Subject<void>();
  onRiskHoverTrigger$: Subject<void> = new Subject<void>();
  enumEntityType = EntityType;
  userId = this.memberService.getLoginUserId();

  constructor(private memberService: MemberInsurerServiceService, private dialog: MatDialog,
    private router: Router, private restService: MemberInsurerRestService
  ) {
  }

  ngOnInit() {
    this.memberService.sidebarExpanded$.subscribe((expanded) => {
      console.log('Sidebar expanded state:', expanded);
      if (expanded) {
        this.isSidebarExpanded = false;
      } else {
        this.isSidebarExpanded = true;
      }
    });

    this.getWholeCounts();
    this.getStatusCountsFor6Months();
    // this.getLatestRequests();
  }
  getWholeCounts() {
    this.restService.getDistributorStatusCounts(this.userId).subscribe(res => {
      if (res) {
        this.statusCards = [
          {
            title: 'Draft (Awaiting submission)',
            count: res['DRAFTED'] || 0,
            svgIcon: 'assets/images/draft.gif',
            viewText: 'View entire list',
            trigger$: this.draftHoverTrigger$
          },
          {
            title: 'Submitted (Awaiting insurer)',
            count: res['SUBMITTED_AWAITING_INSURER'] || 0,
            svgIcon: 'assets/images/load.gif',
            viewText: 'View entire list',
            trigger$: this.submittedAwaitingInsurerHoverTrigger$
          },
          {
            title: 'Submitted (Awaiting Acceptance)',
            count: res['SUBMITTED_AWAITING_ACCEPTANCE'] || 0,
            svgIcon: 'assets/images/submit.gif',
            viewText: 'View entire list',
            trigger$: this.submittedAwaitingAcceptanceHoverTrigger$
          },
          {
            title: 'Declined by insurer',
            count: res['DECLINED_BY_INSURER'] || 0,
            svgIcon: 'assets/images/delete.gif',
            viewText: 'View entire list',
            trigger$: this.declinedByInsurerHoverTrigger$
          },
          {
            title: 'Not taken Up [NTU]',
            count: res['NOT_TAKEN_UP'] || 0,
            svgIcon: 'assets/images/Error.gif',
            viewText: 'View entire list',
            trigger$: this.notTakenUpHoverTrigger$
          },
          {
            title: 'On risk',
            count: res['ON_RISK'] || 0,
            svgIcon: 'assets/images/Risk.gif',
            viewText: 'View entire list',
            trigger$: this.onRiskHoverTrigger$
          }
        ];
      }
    });
  }



  formatTitle(key: string): string {
    // Format keys like "MORE_INFO_REQUESTED" → "More Info Requested"
    return key
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase());
  }

  patientsList: any[] = [];

  getLatestRequests() {
    this.patientsList = [];
    this.restService.getAllLatestReqToInsurer().subscribe(res => {
      if (res) {
        this.patientsList = res;
      }
    }, err => {
      this.patientsList = [];
    })
  }

  // Hover trigger methods
  onDraftHover(): void {
    this.draftHoverTrigger$.next();
  }

  onReqClick(index: number) {
    this.router.navigate(['/dashboard/distributor/applicants'], {
      // state: { id: row.status }
      state: { index: 0 }
    });
  }

  onCardClick(index: number) {
    this.router.navigate(['/dashboard/distributor/applicants'], {
      state: { index }
    });
  }

  onSubmittedAwaitingInsurerHover(): void {
    this.submittedAwaitingInsurerHoverTrigger$.next();
  }

  onSubmittedAwaitingAcceptanceHover(): void {
    this.submittedAwaitingAcceptanceHoverTrigger$.next();
  }

  onDeclinedByInsurerHover(): void {
    this.declinedByInsurerHoverTrigger$.next();
  }

  onNotTakenUpHover(): void {
    this.notTakenUpHoverTrigger$.next();
  }

  onOnRiskHover(): void {
    this.onRiskHoverTrigger$.next();
  }

  // Card hover methods
  onCardHover(index: number): void {
    switch (index) {
      case 0:
        this.onDraftHover();
        break;
      case 1:
        this.onSubmittedAwaitingInsurerHover();
        break;
      case 2:
        this.onSubmittedAwaitingAcceptanceHover();
        break;
      case 3:
        this.onDeclinedByInsurerHover();
        break;
      case 4:
        this.onNotTakenUpHover();
        break;
      case 5:
        this.onOnRiskHover();
        break;
    }
  }

  onCardLeave(): void {
    // Optional: Add any cleanup logic here if needed
  }

  // Status cards data matching the image design
  statusCards: any[] = [];

  onAddApplicant() {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '900px';
    dialogConfig.height = '600px'
    this.dialog.open(AddApplicantComponent, dialogConfig)
  }
  goToPatients() {
    this.router.navigate(['/dashboard/distributor/applicants'])
  }

  // Get a reference to the chart directive
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  // Change this to 'doughnut' for a donut chart
  public chartType: ChartType = 'doughnut';

  public chartData: ChartConfiguration<'doughnut'>['data'] = {
    labels: [],
    datasets: [
      {
        label: 'Status Count',
        data: [],
        backgroundColor: [
          '#bfdbfe',
          '#fde68a',
          '#a7f3d0',
          '#fecaca',
          '#e9d5ff',
          '#fca5a5'
        ],
        hoverBackgroundColor: [
          '#93c5fd',
          '#fcd34d',
          '#6ee7b7',
          '#f87171',
          '#d8b4fe',
          '#f87171'
        ],
        borderWidth: 0,
        hoverOffset: 8
      }
    ]
  };

  public chartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 8,
        right: 32,
        bottom: 8,
        left: 8
      }
    },
    plugins: {
      legend: {
        display: false, // we are showing a custom legend
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: '#fff',
        borderColor: '#ccc',
        borderWidth: 1,
        titleColor: '#222',
        bodyColor: '#333',
        padding: 10
      }
    }
  };
  
  getStatusCountsFor6Months() {
    this.restService.getDistributorStatusCountsFor6Months(this.userId).subscribe((res: any[]) => {
      if (!res || res.length === 0) {
        this.populateChartData({});
        return;
      }

      const statuses = Object.keys(res[0].data);
      const aggregated: Record<string, number> = {};
      statuses.forEach(status => aggregated[status] = 0);

      res.forEach(item => {
        statuses.forEach(status => {
          aggregated[status] += item.data[status] ?? 0;
        });
      });

      console.log("aggregated", aggregated);
      this.populateChartData(aggregated);
    });
  }

  populateChartData(data: Record<string, number>) {
    const values = Object.values(data);
    const hasData = values.some(v => v > 0);

    if (hasData) {
      const labels = Object.keys(data).map(key => this.formatTitle2(key));
      const filteredValues = values.filter((value, index) => value > 0);
      const filteredLabels = labels.filter((label, index) => values[index] > 0);

      this.chartData.labels = filteredLabels;
      this.chartData.datasets[0].data = filteredValues;

      // Reset colors to the original set
      this.chartData.datasets[0].backgroundColor = [
        '#bfdbfe', '#fde68a', '#a7f3d0', '#fecaca', '#e9d5ff', '#fca5a5'
      ];
      this.chartData.datasets[0].hoverBackgroundColor = [
        '#93c5fd', '#fcd34d', '#6ee7b7', '#f87171', '#d8b4fe', '#f87171'
      ];

    } else {
      this.chartData.labels = ['No Data'];
      this.chartData.datasets[0].data = [1];
      // Set colors for no data case
      this.chartData.datasets[0].backgroundColor = ['#e5e7eb'];
      this.chartData.datasets[0].hoverBackgroundColor = ['#e5e7eb'];
    }

    // This is the crucial step to force the chart to re-render
    if (this.chart) {
      this.chart.update();
    }
  }

  formatTitle2(key: string): string {
    return key.replace(/_/g, ' ');
  }

  get legendItems(): { label: string; color: string }[] {
    const labels = (this.chartData.labels || []) as string[];
    const colors = (this.chartData.datasets[0].backgroundColor || []) as string[];
    return labels.map((label, index) => ({
      label,
      color: colors[index] || '#999'
    }));
  }

}
